/* Kailar Neubau D · Longpapers „Alle Sorten“ (sections/d-longpaper.liquid).
   Variante, Preis, Bild, Menge und Kaufleiste macht d-product.js. Diese Datei ergänzt nur, was es dort nicht gibt:
   - Box-Größe hängt an der Sorte (40 oder 50 Booklets): beim Sortenwechsel bleibt „Box“ gewählt, nur die passende Kachel ist sichtbar;
   - Packungspreise und „pro Booklet“ je Sorte; Preis pro Booklet neben dem Preis;
   - Beschreibung der gewählten Sorte (alte Emoji-Haken werden zur Liste, „👉 Jetzt sichern“ fällt weg);
   - Unterzeile der Kaufleiste mit Sorte und Format. Nichts bewegt sich. */
(() => {
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const money = (c) => (c / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';

  function tidy(box) {
    $$('p', box).forEach((p) => {
      const txt = p.textContent.trim();
      if (!txt && !$('img[src], iframe, video', p)) { p.remove(); return; }
      if (/^👉/u.test(txt)) { p.remove(); return; }
      if (/✔️|✔/u.test(txt)) {
        const items = p.innerHTML.split(/<br\s*\/?>/i).map((h) => h.replace(/✔️|✔/gu, '').trim()).filter(Boolean);
        const ul = document.createElement('ul'); ul.className = 'lp-hl';
        items.forEach((h) => { const li = document.createElement('li'); li.innerHTML = h; ul.append(li); });
        p.replaceWith(ul);
      }
    });
    $$('img:not([src])', box).forEach((i) => i.remove());
  }

  function init(root) {
    if (root.lpReady) return; root.lpReady = true;
    const sec = root.closest('.shopify-section') || root.parentElement;
    let D, L;
    try { D = JSON.parse($('[data-dp-data]', sec).textContent); L = JSON.parse($('[data-lp-data]', sec).textContent); } catch (e) { return; }
    const P = L.paper, F = L.format;
    const nOf = (b) => Number(b.dataset.lpN) || 1;
    const packs = $$(`[data-dp-opt="${F}"] [role="radio"]`, root);
    const checked = (i) => $(`[data-dp-opt="${i}"] [role="radio"][aria-checked="true"]`, root);
    const find = (paper, format) => D.variants.find((v) => v.options[P] === paper && v.options[F] === format);
    const bar = $('[data-dp-bar]', root) || $('[data-dp-bar]');
    $$('[data-lp-desc]', root).forEach(tidy);

    function sync() {
      const pb = checked(P), fb = checked(F);
      if (!pb || !fb) return;
      const paper = pb.dataset.value;
      /* Box-Größe der Sorte: gibt es die gewählte Kombination nicht, die andere Box derselben Art wählen */
      if (!find(paper, fb.dataset.value)) {
        const box = nOf(fb) > 1;
        const alt = packs.find((b) => (nOf(b) > 1) === box && find(paper, b.dataset.value)) || packs.find((b) => find(paper, b.dataset.value));
        if (alt && alt !== fb) { alt.click(); return; }
      }
      packs.forEach((b) => {
        const v = find(paper, b.dataset.value);
        b.hidden = !v;
        if (!v) return;
        const n = nOf(b);
        const p = $('[data-lp-packprice]', b); if (p) p.textContent = money(v.price);
        const c = $('[data-lp-packct]', b); if (c) c.textContent = n > 1 ? L.perBooklet.replace('__PRICE__', money(Math.round(v.price / n))) : L.booklet;
      });
      /* d-product.js blasst Sorten ab, die es im exakten Format nicht gibt (Box 50 nur bei Unbleached): hier zählt Booklet oder Box */
      const boxNow = nOf(checked(F) || fb) > 1;
      $$(`[data-dp-opt="${P}"] [role="radio"]`, root).forEach((t) => {
        const ok = D.variants.some((x) => x.options[P] === t.dataset.value && x.available && (nOf(packs.find((b) => b.dataset.value === x.options[F]) || fb) > 1) === boxNow);
        t.classList.toggle('is-out', !ok);
      });
      const f = checked(F), v = f && find(paper, f.dataset.value);
      const unit = $('[data-lp-unit]', root);
      if (unit) {
        const n = f ? nOf(f) : 1;
        unit.textContent = v && n > 1 ? L.perBooklet.replace('__PRICE__', money(Math.round(v.price / n))) : '';
        unit.hidden = !unit.textContent;
      }
      const descs = $$('[data-lp-desc]', root);
      const own = descs.find((d) => d.dataset.lpDesc === paper);
      descs.forEach((d) => { d.hidden = own ? d !== own : d.dataset.lpDesc !== ''; });
      const bs = bar && $('[data-dp-barsub]', bar);
      if (bs && f) bs.textContent = `${paper} · ${f.dataset.lpLabel || f.dataset.value}`;
    }

    /* nach d-product.js: das hört auf dem Abschnitt, wir auf document (Bubble kommt später an) */
    document.addEventListener('click', (e) => {
      const b = e.target.closest('[data-dp-opt] [role="radio"]');
      if (b && root.contains(b)) sync();
    });
    sync();
  }

  const start = (scope = document) => $$('[data-lp]', scope).forEach(init);
  document.addEventListener('shopify:section:load', (e) => start(e.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start()); else start();
})();
